module.exports = __webpack_public_path__ + "static/img/nampeera.91d01ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads/nampeera.jpg
// module id = 95
// module chunks = 1